import { ref } from 'vue';
import { defineStore } from 'pinia';
import type { components } from '@/constants/schema';
import type { MediaType } from '@/utils/getMediaType';

export const useMediaStore = defineStore('useMediaStore', () => {
  const type = ref<MediaType>();
  const src = ref<string>();
  const preview = ref<string>();
  const name = ref<string>();
  const downloadUrl = ref<string>();
  const fileSize = ref<number>();
  const icon = ref<string>();

  const messageContent = ref<string>();
  const messageAttachments = ref<components['schemas']['MessageDetail']['attachments']>();
  const messageCreatedAt = ref<string>();

  return {
    type,
    src,
    preview,
    name,
    downloadUrl,
    fileSize,
    icon,
    messageContent,
    messageAttachments,
    messageCreatedAt,
  };
});
